import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Window, Loading, EmptyState } from "../../components/VB";
import SlipGaji from "../../components/SlipGaji";
import { toast } from "sonner";
import { Printer } from "lucide-react";

export default function SlipGajiSaya() {
  const [bulan, setBulan] = useState(new Date().toISOString().slice(0, 7));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const load = async () => {
    setLoading(true);
    setErr("");
    try {
      const { data } = await api.get("/payroll/slip", { params: { bulan } });
      setData(data);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail));
      setData(null);
    }
    setLoading(false);
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <Window title="Slip Gaji Saya">
      <div className="no-print" style={{ display: "flex", gap: 6, marginBottom: 10, flexWrap: "wrap" }}>
        <input type="month" className="vb-input" style={{ width: 160 }} value={bulan} onChange={(e) => setBulan(e.target.value)} data-testid="slip-bulan" />
        <button className="vb-btn-primary" onClick={load} data-testid="slip-load">Tampilkan</button>
        {data && (
          <button className="vb-btn" onClick={() => window.print()} data-testid="slip-print">
            <Printer className="w-3 h-3 inline mr-1" />Cetak Slip Gaji
          </button>
        )}
      </div>

      {loading ? <Loading /> : err ? <EmptyState message={err} /> : !data ? <EmptyState /> : (
        <SlipGaji data={data} />
      )}
    </Window>
  );
}
